import { render, staticRenderFns } from "./cTextEditDialogue.vue?vue&type=template&id=f3f0e144&scoped=true"
import script from "./cTextEditDialogue.vue?vue&type=script&lang=js"
export * from "./cTextEditDialogue.vue?vue&type=script&lang=js"
import style0 from "./cTextEditDialogue.vue?vue&type=style&index=0&id=f3f0e144&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f0e144",
  null
  
)

export default component.exports